
<template>
  <section class="sm-top">
    <div class="sm-wrap">
      <div class="sm-top-inner">
        <div class="sm-top__flex">
          <div class="sm-top__row">
            <div class="sm-top__title">
              <a
                href="#" 
                @click.prevent="$router.push('mail')"
              >
                <include-svg :name="'icon-mail'" />
              </a>
              <h2>Mail</h2>
            </div>
            <tabs-elem
              :key="`tabs-key-${tabsKey}`"
              :tabs="tabs"
              :param="'status'"
              @switch="switchTab($event.status)"
            />
          </div>
          <div 
            v-if="list && list.mail_items && list.mail_items.length"  
            class="sm-top__controls"
          >
            <input-search
              v-model="search"
              :defaultVal="searchStartVal"
              @submit="sendSearchReq"
              @input="checkInput"
            />
            <btn-block 
              :type="'filters'" 
              :text="'Filters'" 
              :icon="'icon-filters'" 
              :hints="filtersSelected"
              @click="toggleFilters"
            />
          </div>
        </div>
        <transition
          name="filtersFade"
        >
          <div v-if="showFilters && !isMobile" class="sm-top__filters">
            <div class="sm-top__filters-inner">
              <div class="sm-top__filters-items">
                <h4>Filters:</h4>
                <dropdown-block 
                  class="sm-dropdown"
                  v-model="filters.types" 
                  :options="mailTypes"
                  :multiple="true"
                  :close-on-select="false"
                  label="name"
                  track-by="name"
                  placeholder="Type..."
                  @select="selectAction"
                >
                  <template 
                    slot="selection" 
                    slot-scope="{ values, search, isOpen }"
                  >
                    <span 
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                    >
                      <span>Type</span>
                      <include-svg :name="'icon-arrow-b'" />
                    </span>
                  </template>
                  <template slot="placeholder">
                    <span>
                      Type
                    </span>
                    <include-svg :name="'icon-arrow-b'" />
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <span>
                      {{ props.option.name }}
                    </span>
                    <include-svg :name="'icon-arrow-b'" />
                  </template>
                  <template 
                    slot="option" 
                    slot-scope="props" 
                    :value="props.option.name"
                  >
                    <checkbox-block />
                    <span class="sm-txt-capitalize">
                      {{ props.option.name }}
                    </span>
                  </template>
                </dropdown-block>

                <datepicker-wrap
                  :val="filters.date"
                  @input="filters.date = $event"
                />
              </div>
              <div class="sm-top__filters-controls">
                <a 
                  href="#" 
                  class="sm-top__filters-controls-clear"
                  @click.prevent="clearFilters"
                >
                  Clear
                </a>
                <btn-block
                  :type="'small'"
                  :text="'Apply'"
                  @click="applyFilters"
                />
              </div>
            </div>
          </div>
        </transition>
        <transition
          name="mobileFiltersFade"
        >
          <div 
            v-if="showFilters && isMobile"
            class="sm-top__mobile-filters"
          >
            <div class="sm-top__mobile-filters-top">
              <!-- <a 
                href="/" 
                class="sm-top__mobile-filters-top-logo"
                :style="`background-image: url(${logo});`"
                @click.prevent="$router.push('/')"
              ></a> -->
              <a 
                :href="provider.website_url || '/'" 
                class="sm-top__mobile-filters-top-logo"
                target="_blank"
              >
                <img-loader :src="logo" />
              </a>
              <a 
                href="#" 
                class="sm-top__mobile-filters-top-close"
                @click.prevent="toggleFilters"
              ></a>
            </div>
            <div 
              class="sm-top__mobile-filters-main"
              :class="filtersSelected > 0 ? 'selected' : ''"
            >
              <div class="sm-top__mobile-filters-main-title">
                <a
                  v-if="activeFilter.length"
                  href="#" 
                  class="sm-top__mobile-filters-main-title-back"
                  @click.prevent="hideFilter"
                >
                  <span></span>
                </a>
                <h4>Filters</h4>
                <a 
                  v-if="(filters.date || filters.types.length) && !activeFilter"
                  href="#" 
                  class="sm-top__mobile-filters-main-title-clear"
                  @click.prevent="clearFilters"
                >
                  Clear
                </a>
                <a href="#" class="sm-top__mobile-filters-main-title-select">Select all</a>
              </div>
              <div class="sm-top__mobile-filters-main-content">
                <ul class="sm-top__mobile-filters-main-content-menu">
                  <li @click="showFilter('type')">
                    <div>Mail type</div>
                  </li>
                  <li @click="showFilter('date')">
                    <div>Date</div>
                  </li>
                </ul>
                <div 
                  class="sm-top__mobile-filters-main-content-filter"
                  :class="activeFilter == 'type' ? 'active' : ''"
                >
                  <ul>
                    <li
                      v-for="type in mailTypes"
                      :key="type.id"
                      :class="filters.types.includes(type) ? 'selected' : ''"
                      @click="toggleMailType(type)"
                    >
                      <span class="sm-txt-capitalize">{{type.name}}</span>
                    </li>
                  </ul>
                </div>
                <div 
                  class="sm-top__mobile-filters-main-content-filter datepicker"
                  :class="activeFilter == 'date' ? 'active' : ''"
                >
                  <datepicker-wrap
                    v-model="filters.date"
                    :val="filters.date"
                    :inline="true"
                  />
                </div>
              </div>
              <div class="sm-top__mobile-filters-main-bottom">
                <btn-block
                  :type="'small'" 
                  :text="'View mail'"
                  @click="applyFilters"
                />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import Btn from '@/components/Buttons';
import Checkbox from '@/components/Checkboxes';
import IncludeSvg from '@/components/IncludeSvg';
import InputSearch from '@/components/InputSearch';
import {GetMailTypes} from '@/api/general-data';
import Multiselect from 'vue-multiselect';
import DatepickerWrap from '@/components/DatepickerWrap';
import { mapActions, mapGetters } from 'vuex';
import imageStore from '@/utils/image-store';
import ImgLoader from '@/components/ImgLoader';
import Tabs from '@/components/Tabs';

export default {
  name: 'mail-top',
  components: {
    'btn-block': Btn,
    'checkbox-block': Checkbox,
    'include-svg': IncludeSvg,
    'input-search': InputSearch,
    'dropdown-block': Multiselect,
    'datepicker-wrap': DatepickerWrap,
    'img-loader': ImgLoader,
    'tabs-elem': Tabs
  },
  data() {
    return {
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      filters: {
        types: [],
        date: ''
      },
      showFilters: false,
      activeFilter: '',
      search: '',
      searchStartVal: '',
      searchTimer: 0,
      searchTimerUpdate: 100,
      seachWait: 1000,
      tabs: [{
        status: 'new',
        text: 'New'
      },
      {
        status: 'pending',
        text: 'Pending'
      },
      {
        status: 'processed',
        text: 'Processed'
      },
      {
        status: 'junk',
        text: 'Junk'
      },
      {
        status: 'stored',
        text: 'Stored'
      },
      {
        status: 'all',
        text: 'All mail'
      }],
      currentTab: null,
      tabsKey: 0
    }
  },
  created() {
    let query = this.$route.query;

    if (query.status) {
      this.tabs.some(tab => {
        if (tab.status == query.status) {
          this.currentTab =  tab;
          return true;
        }
      });
    } else {
      this.currentTab =  this.tabs[0];
    }

    this.updateTabsData();

    this.getMailTypes()
      .then(() => this.getCurrentFilters());
    
    this.searchTimer = setInterval(() => this.searchTimer += this.searchTimerUpdate, this.searchTimerUpdate);
  },
  methods: {
    ...mapActions({
      getMailTypes: 'getMailTypes'
    }),
    toggleMailType(type) {
      if (this.filters.types.includes(type)) {
        let index = this.filters.types.indexOf(type);
        this.filters.types.splice(index, 1);
      } else {
        this.filters.types.push(type);
      }
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    applyFilters() {
      this.showFilters = false;
      let filtersQuery = {};
      let queryParamsToClear = [];

      if (this.filters.types) {
        filtersQuery.type = [];
        this.filters.types.forEach(type => {
          filtersQuery.type.push(type.id);
        });
      } else if (this.$route.query.type) {
        queryParamsToClear.push('type');
      }

      if (this.filters.date) {
        filtersQuery.received_at = this.filters.date;
      } else if (this.$route.query.received_at) {
        queryParamsToClear.push('received_at');
      }

      if (Object.keys(filtersQuery).length) {
        this.$router.push({
          query: {
            ...this.$route.query,
            ...filtersQuery
          }
        });
      }

      if (queryParamsToClear.length)
        this.clearQueryParams(queryParamsToClear);
    },
    clearFilters() {
      this.showFilters = false;
      
      this.filters = {
        date: '',
        types: []
      };

      this.clearQueryParams(['type', 'received_at']);
    },
    clearQueryParams(paramArr) {
      let query = Object.assign({}, this.$route.query);
      paramArr.forEach(param => delete query[param]);

      if (JSON.stringify(query) != JSON.stringify(this.$route.query))
        this.$router.push({query});
    },
    showFilter(filter) {
      this.activeFilter = filter;
    },
    hideFilter() {
      this.activeFilter = '';
    },
    sendSearchReq() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...{
            search: this.search
          }
        }
      });
    },
    checkInput() {
      if (this.search.length < 2) {
        if (!this.search.length)
          this.clearQueryParams(['search']);
          
        return;
      }

      setTimeout(() => {
        if (this.searchTimer > this.seachWait) {
          this.sendSearchReq();
          this.searchTimer = 0;
        }
      }, this.seachWait);
    },
    selectAction(obj) {
    },
    getCurrentFilters() {
      let query = this.$route.query;

      if (query.type) {
        if (typeof query.type == 'string')
          this.filters.types.push(this.mailTypes.find(type => type.id == query.type));
        else
          query.type.forEach(item => {
            this.filters.types.push(this.mailTypes.find(type => type.id == item));
          });
      }

      if (query.received_at)
        this.filters.date = query.received_at;

      if (query.search)
        this.searchStartVal = query.search;
    },
    switchTab(status) {
      this.$router.push({
        query: {
          status
        }
      })
    },
    updateTabsData() {
      if (!this.list.total)
        return;

      this.tabsKey++;

      this.tabs.forEach(tab => {
        if (this.list.total.hasOwnProperty(tab.status) && tab.status != 'all' && tab.status != 'junk')
          tab.items = this.list.total[tab.status] < 100 ? this.list.total[tab.status] : '99+';
      });
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      mailTypes: 'mailTypes',
      provider: 'provider',
      list: 'mail/list'
    }),
    filtersSelected() {
      //return Object.keys(this.filters).some(filter => this.filters[filter].length > 0);
      let res = this.filters.types.length;

      if (this.filters.date.length)
        res++;

      return res;
    },
    logo() {
      return imageStore(this.provider.image_url);
    }
  },
  watch: {
    '$route.query'(val) {
      if (!val.type) {
        this.filters.types = [];
      }

      if (!val.received_at) {
        this.filters.date = '';
      }
    },
    'filters.date'(val) {
      if (val)
        this.hideFilter();
    },
    list(val) {
      this.updateTabsData();
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/customer/mail/_top.scss';

   .filtersFade-enter,
   .filtersFade-leave-to {
     transform: scale(1, 0);

     .sm-top__filters-inner {
       opacity: 0;
     }
   }

  .filtersFade-enter-active {
    transition: transform .5s;
    
    .sm-top__filters-inner {
       transition: opacity .2s .3s;
     }
  }

  .filtersFade-leave-active {
    transition: transform .2s .05s;

    .sm-top__filters-inner {
      
       transition: opacity .1s;
     }
  }

  .mobileFiltersFade-enter,
  .mobileFiltersFade-leave-to {
    left: 100%;
  }
</style>
